// ¿Hay llave para cobrar con Stripe? Sin ella no hay con qué pagar: un servicio con precio no se puede reservar.
export const pagosDisponibles = () => Boolean(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
